import type Quill from 'quill/core';
import { BlockEmbed } from 'quill/blots/block';
import type { EmbedBlot, Range } from './types';
import isSelectableInlineEmbed from './utils/isSelectableInlineEmbed';

const getSelectedEmbed = (
  quill: Quill,
  range: Range | null = quill.getSelection(),
): EmbedBlot | null => {
  if (!range || range.length > 1) return null;
  const [leaf, offset] = quill.getLeaf(range.index);
  if (
    leaf instanceof BlockEmbed ||
    (isSelectableInlineEmbed(leaf) && offset === 0)
  ) {
    return leaf;
  }
  if (range.length === 1) {
    const [nextLeaf, nextOffset] = quill.getLeaf(range.index + 1);
    if (isSelectableInlineEmbed(nextLeaf) && nextOffset === 1) {
      return nextLeaf;
    }
  }
  return null;
};

export default getSelectedEmbed;
